import { SobaSuspense } from '../index';
import useSettings from '../../hooks/useSettings';
import { SobaLayouts } from './index';

const SobaLayout = (props) => {
  const { settings } = useSettings();
  const Layout = SobaLayouts[settings.activeLayout];

  return (
    <SobaSuspense>
      <Layout {...props} />
    </SobaSuspense>
  );
};

export default SobaLayout;
